import React, { useState } from "react";
import Card from "components/card";
import CenteredSlideshow, { Slide } from "components/centered-slideshow";
import { shopURL } from "utils/constants";
import OgrLogo from "images/ogr-small-logo.jpeg";
import Modal from "components/modal";
import "./styles.scss";
import StepsComponents from "components/steps-components";
import { CouponModalContent, Image, Button } from "components/coupons/helpers";
import { navigate } from "gatsby";

const centeredSlideshowConfig = (slidesPerView) => ({
  breakpoints: {
    300: {
        slidesPerView: 1.2,
        centeredSlides: true,
        spaceBetween: 14,
    },
    768: {
        slidesPerView: (slidesPerView - 1 < 1) ? 1 : slidesPerView - 1,
        centeredSlides: false,
    },
    1024: {
        slidesPerView: slidesPerView,
        centeredSlides: false,
    },
  },
  slidesPerView: slidesPerView,
})

const Coupons = ({ data }) => {
  const { listOfCoupons, numberPerSlides } = data;
  const [modal, setModal] = useState({ isOpen: false, index: undefined, currentStep: 0 });
  if (!listOfCoupons || !listOfCoupons?.length) return <></>;
  
  const currentCoupon = listOfCoupons[modal.index];


  return (
    <>
      {modal.isOpen && (
        <Modal
          contentClassName="coupons-modal"
          onClose={() => setModal((prevState) => ({ ...prevState, isOpen: false, currentStep: 0 }))}
        >
          <StepsComponents
            current={modal.currentStep}
            props={
              {
                onClose: () => setModal((prevState) => ({ ...prevState, isOpen: false, currentStep: 0 })),
                onGoBack: () => setModal((prevState) => ({ ...prevState, currentStep: prevState.currentStep - 1 })),
                onNext: () => navigate(`${shopURL}/the-club-horse`),
                coupon: currentCoupon
              }
            }
            Components={[CouponModalContent]}      
          />
        </Modal>
      )}
      <div className="coupons">
        <div className="mb-8 container">
          <div>
            <h2 className="header mb-2.5">{data.title}</h2>
            <p className="text-gray-700 font-montserrat font-medium text-lg sm:text-base">{data.description}</p>
          </div>
        </div>
        <div className="overflow-hidden container !max-w-[calc(100%-(100%-1280px)/2)] !mr-0 !pr-0 sm:ml-0 sm:pl-0">
          <CenteredSlideshow extraConfig={centeredSlideshowConfig(numberPerSlides || 1)}>
              {listOfCoupons.map((item, index) => {
                const { name, discountValue, validity, image, _key } = item;
                
                return (
                  <Slide key={_key}> 
                      <Card
                        bannerText={discountValue}
                        authorImage={OgrLogo}
                        Image={<Image image={image.src} />}
                        author="Old Gold Racing"
                        date={`${validity} months`}
                        title={name}
                        description={`Valid for: ${validity} months`}
                        Button={  
                          <Button
                            text="Learn More" 
                            onClick={() => setModal((prevState) => ({ ...prevState, isOpen: true, index }))}
                          />
                        }
                      />
                  </Slide>
                )})}
            </CenteredSlideshow>
        </div>
      </div>
    </>
  );
};

export default Coupons;
